import React from "react";
import { Link } from "react-router-dom";
import "./CommunityPage.css";

// Social Media Icons
function InstagramIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
    </svg>
  );
}

function FacebookIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
  );
}

function TwitterIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
    </svg>
  );
}

function MailIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <polyline points="22,6 12,13 2,6"/>
    </svg>
  );
}

function HeartIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

function UsersIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  );
}

function SparklesIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
      <path d="M20 3v4"/>
      <path d="M22 5h-4"/>
      <path d="M4 17v2"/>
      <path d="M5 18H3"/>
    </svg>
  );
}

export default function CommunityPage() {
  return (
    <div className="mariamly-community-page">
      {/* Banner Section */}
      <div className="community-banner">
        <div className="community-banner-content">
          <h1 className="community-banner-title">Community</h1>
          <div className="community-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Community</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="community-content">
        {/* Welcome Section */}
        <div className="community-welcome">
          <div className="welcome-content">
            <h2>Welcome to the Mariamly Luxe Community 🌸</h2>
            <p>
              At Mariamly Luxe, beauty is more than products—it's people. Our community is a space where beauty lovers, 
              creators, and dreamers come together to share inspiration, celebrate diversity, and uplift one another.
            </p>
            <p>
              Here, every voice is heard, and every story matters. Whether it's through tutorials, beauty tips, 
              or shared experiences, our community thrives on connection and confidence.
            </p>
          </div>
          <div className="welcome-image">
            <div className="image-placeholder">
              <HeartIcon size={48} color="#d19e90" />
            </div>
          </div>
        </div>

        {/* Community Values */}
        <div className="community-values">
          <h3>Our Community Values</h3>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <UsersIcon size={32} />
              </div>
              <h4>Inclusivity</h4>
              <p>Every beauty lover is welcome, regardless of background, skin tone, or experience level.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <HeartIcon size={32} />
              </div>
              <h4>Support</h4>
              <p>We lift each other up, sharing knowledge, encouragement, and celebrating every win.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <SparklesIcon size={32} />
              </div>
              <h4>Creativity</h4>
              <p>Express your unique style and inspire others with your beauty journey and artistic vision.</p>
            </div>
          </div>
        </div>

        {/* Join Our Journey */}
        <div className="join-journey">
          <h3>✨ Be part of our journey:</h3>
          <div className="journey-options">
            <div className="journey-option">
              <div className="option-icon">
                <InstagramIcon size={28} />
              </div>
              <div className="option-content">
                <h4>Follow us on social media</h4>
                <p>Stay connected with @mariamly.luxe for daily inspiration, beauty tips, and behind-the-scenes content.</p>
                <a href="https://www.instagram.com/mariamly.luxe/" target="_blank" rel="noopener noreferrer" className="social-link">
                  Follow on Instagram
                </a>
              </div>
            </div>
            <div className="journey-option">
              <div className="option-icon">
                <MailIcon size={28} />
              </div>
              <div className="option-content">
                <h4>Join our newsletter</h4>
                <p>Get insider updates, exclusive beauty launches, and special offers delivered to your inbox.</p>
                <a href="mailto:newsletter@mariamlyluxe.com" className="social-link">
                  Subscribe Now
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Community Promise */}
        <div className="community-promise">
          <div className="promise-content">
            <h3>Together, we are redefining beauty</h3>
            <p>
              One story, one look, one glow at a time. Join our community and be part of a movement that celebrates 
              authentic beauty, empowers self-expression, and creates lasting connections through shared passion.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
